import React from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { RouterProvider } from 'react-router-dom';
import { theme } from '@/theme/index';
import { router } from '@/router/index';
import { ApiErrorNotifier } from '@/components/common/ApiErrorNotifier';
import '@/styles/global.css';

/**
 * 应用入口：挂载 React，注入 ThemeProvider + CssBaseline + RouterProvider
 * ApiErrorNotifier 挂在 RouterProvider 外层，不受路由跳转影响
 */
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <ApiErrorNotifier />
      <RouterProvider router={router} />
    </ThemeProvider>
  </React.StrictMode>,
);
